import { render, staticRenderFns } from "./IndexAuthor.vue?vue&type=template&id=16b28586&scoped=true&"
import script from "./IndexAuthor.vue?vue&type=script&lang=js&"
export * from "./IndexAuthor.vue?vue&type=script&lang=js&"
import style0 from "./IndexAuthor.vue?vue&type=style&index=0&id=16b28586&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b28586",
  null
  
)

export default component.exports